import { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from "@mui/material";
import api from "../../utils/api";

export default function AdminTrialManagementPage() {
  const [users, setUsers] = useState([]);
  const [modal, setModal] = useState({ open: false, action: null, user: null });
  const [form, setForm] = useState({ exam_limit: 3, days: 7 });

  const loadUsers = async () => {
    const res = await api.get("/admin/trials");
    setUsers(res.data);
  };

  useEffect(() => {
    loadUsers();
  }, []);

  const isTrialActive = (u) => u.is_trial_active;

  const handleConfirm = async () => {
    const { action, user } = modal;

    const map = {
      grant: { url: "/admin/trials/grant", method: "post" },
      extend: { url: "/admin/trials/extend", method: "patch" },
      reset: { url: "/admin/trials/reset", method: "patch" },
      revoke: { url: "/admin/trials/revoke", method: "patch" },
    };

    const payload = {
      user_id: user.user_id,
      exam_limit: form.exam_limit,
      days: form.days,
      add_exams: form.exam_limit,
      add_days: form.days,
    };

    await api[map[action].method](map[action].url, payload);
    setModal({ open: false });
    loadUsers();
  };

  return (
    <Box>
      <Typography variant="h5" sx={{ mb: 2 }}>
        Trial Management
      </Typography>

      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Email</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Usage</TableCell>
            <TableCell>Expiry</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {users.map((u) => (
            <TableRow key={u.user_id}>
              <TableCell>{u.full_name}</TableCell>
              <TableCell>{u.email}</TableCell>

              <TableCell>
                <Chip
                  label={
                    isTrialActive(u)
                      ? "Active"
                      : u.trial_exam_limit > 0
                      ? "Expired"
                      : "None"
                  }
                  color={isTrialActive(u) ? "success" : "default"}
                />
              </TableCell>

              <TableCell>
                {u.trial_exam_limit > 0
                  ? `${u.trial_exams_used} / ${u.trial_exam_limit}`
                  : "—"}
              </TableCell>

              <TableCell>
                {u.trial_expires_at
                  ? new Date(u.trial_expires_at).toLocaleDateString()
                  : "—"}
              </TableCell>

              <TableCell>
                {u.trial_exam_limit === 0 && (
                  <Button
                    size="small"
                    onClick={() =>
                      setModal({ open: true, action: "grant", user: u })
                    }
                  >
                    Grant
                  </Button>
                )}

                {u.trial_exam_limit > 0 && (
                  <>
                    <Button
                      size="small"
                      onClick={() =>
                        setModal({ open: true, action: "extend", user: u })
                      }
                    >
                      Extend
                    </Button>
                    <Button
                      size="small"
                      color="warning"
                      onClick={() =>
                        setModal({ open: true, action: "reset", user: u })
                      }
                    >
                      Reset
                    </Button>
                    <Button
                      size="small"
                      color="error"
                      onClick={() =>
                        setModal({ open: true, action: "revoke", user: u })
                      }
                    >
                      Revoke
                    </Button>
                  </>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      {/* MODAL */}
      <Dialog open={modal.open} onClose={() => setModal({ open: false })}>
        <DialogTitle>
          {modal.action?.toUpperCase()} TRIAL
        </DialogTitle>

        <DialogContent>
          {(modal.action === "grant" || modal.action === "extend") && (
            <>
              <TextField
                fullWidth
                label="Exam Limit"
                type="number"
                sx={{ mb: 2 }}
                value={form.exam_limit}
                onChange={(e) =>
                  setForm({ ...form, exam_limit: e.target.value })
                }
              />
              <TextField
                fullWidth
                label="Days"
                type="number"
                value={form.days}
                onChange={(e) =>
                  setForm({ ...form, days: e.target.value })
                }
              />
            </>
          )}

          {modal.action === "reset" && (
            <Typography>
              Reset trial usage back to zero.
            </Typography>
          )}

          {modal.action === "revoke" && (
            <Typography color="error">
              This will immediately end the trial.
            </Typography>
          )}
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setModal({ open: false })}>Cancel</Button>
          <Button variant="contained" onClick={handleConfirm}>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
